import { render } from "./indexnewVipRecharge.vue?vue&type=template&id=40846e0f&scoped=true&ts=true"
import script from "./indexnewVipRecharge.vue?vue&type=script&lang=ts"
export * from "./indexnewVipRecharge.vue?vue&type=script&lang=ts"

import "./indexnewVipRecharge.vue?vue&type=style&index=0&id=40846e0f&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40846e0f"]])

export default __exports__